import { MicrositeListType } from '@nkr/enums/index';
import { IMicrositeRecipientForListWithSelect } from './models/microsite-recipient-for-list-with-select';
import { CenterGridWrapper } from '../styles';
import CommonList from './common-list';
import { GridReadyEvent } from 'ag-grid-community';

interface IProps {
    isAdminLogin: boolean,
    centerId: number,
    listType: MicrositeListType,
    list: IMicrositeRecipientForListWithSelect[],
    isLoading: boolean,
    onSelectAllRows: () => void,
    onRowSelected: (id: number, isSelected: boolean) => void,
    onSendReminderEmail: (id: number) => void,
    onGetDonorRegistrationForMSPatients: (id: number) => void,
    onResendApprovalEmail: (id: number) => void,
    onDownloadBatchFile: (id: number) => void,
    onShowLinkedEntities: (id: number) => void,
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void,
    onChangeStatus: (id: number) => void

}

const CenterMicrositeList = (props: IProps) => {
    return (
        <CenterGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                list={props.list}
                listType={props.listType}
                centerId={props.centerId}
                isAdmin={false}
                isAdminLogin={props.isAdminLogin}
                isLoading={props.isLoading}
                onSelectAllRows={props.onSelectAllRows}
                onRowSelected={props.onRowSelected}
                onSendReminderEmail={props.onSendReminderEmail}
                onGetDonorRegistrationForMSPatients={props.onGetDonorRegistrationForMSPatients}
                onResendApprovalEmail={props.onResendApprovalEmail}
                onDownloadBatchFile={props.onDownloadBatchFile}
                onLoadingComplete={props.onLoadingComplete}
                onShowLinkedEntities={props.onShowLinkedEntities}
                onGridReady={props.onGridReady}
                onChangeStatus={props.onChangeStatus}
            />
        </CenterGridWrapper>
    );
}

export default CenterMicrositeList;